import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import logoblack from '../assets/logoblack.png';

export default function Footer() {
  const { lang, t } = useLanguage();

  return (
    <footer>
      {/* Main Footer */}
      <div className="footer-main" style={{ backgroundColor: 'var(--bg-dark)', color: 'var(--text-on-dark)' }}>
        <div className="footer-grid">
          
          {/* Brand Column */}
          <div>
            <div className="footer-brand-row">
              <img src={logoblack} alt="Kaaleen Haus" style={{ height: '40px', objectFit: 'contain' }} />
              <span className="footer-brand-name">KAALEEN HAUS</span>
            </div>
            <p style={{ fontSize: '14px', lineHeight: '1.8', color: '#8a8da0', maxWidth: '280px' }}>
              {lang === 'de' ? t('footer.tagline') : 'Handcrafted luxury rugs blending centuries of artisan tradition with modern design sensibility.'}
            </p>
            {/* Social Icons */}
            <div style={{ display: 'flex', gap: '14px', marginTop: '25px' }}>
              {['instagram', 'facebook', 'linkedin'].map((s) => (
                <a key={s} href="#" style={{ width: '36px', height: '36px', borderRadius: '50%', border: '1px solid var(--border-dark)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#8a8da0', transition: 'all 0.3s ease' }}>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><circle cx="12" cy="12" r="10"></circle></svg>
                </a>
              ))}
            </div>
          </div>

          {/* Shop */}
          <div>
            <h4 style={{ fontSize: '11px', letterSpacing: '2px', textTransform: 'uppercase', marginBottom: '22px', fontWeight: '600', color: 'var(--accent-gold)' }}>{lang === 'de' ? t('footer.shop') : 'Shop'}</h4>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0, fontSize: '14px', lineHeight: '2.2', color: '#8a8da0' }}>
              <li><Link to="/shop" style={{ color: 'inherit' }}>{lang === 'de' ? t('footer.allRugs') : 'All Rugs'}</Link></li>
              <li><Link to="/shop?sort=newest" style={{ color: 'inherit' }}>{lang === 'de' ? t('footer.newArrivals') : 'New Arrivals'}</Link></li>
              <li><Link to="/shop" style={{ color: 'inherit' }}>{lang === 'de' ? t('home.bestsellers.title') : 'Bestsellers'}</Link></li>
              <li><Link to="/custom" style={{ color: 'inherit' }}>{lang === 'de' ? t('footer.custom') : 'Custom Orders'}</Link></li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 style={{ fontSize: '11px', letterSpacing: '2px', textTransform: 'uppercase', marginBottom: '22px', fontWeight: '600', color: 'var(--accent-gold)' }}>{lang === 'de' ? t('footer.company') : 'Company'}</h4>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0, fontSize: '14px', lineHeight: '2.2', color: '#8a8da0' }}>
              <li><Link to="/stories" style={{ color: 'inherit' }}>{lang === 'de' ? t('footer.stories') : 'Our Story'}</Link></li>
              <li><Link to="/trade" style={{ color: 'inherit' }}>{lang === 'de' ? t('footer.trade') : 'Trade Program'}</Link></li>
              <li><Link to="/blog" style={{ color: 'inherit' }}>{lang === 'de' ? t('footer.blog') : 'Blog'}</Link></li>
              <li><Link to="/contact" style={{ color: 'inherit' }}>{lang === 'de' ? t('footer.contact') : 'Contact'}</Link></li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h4 style={{ fontSize: '11px', letterSpacing: '2px', textTransform: 'uppercase', marginBottom: '22px', fontWeight: '600', color: 'var(--accent-gold)' }}>Support</h4>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0, fontSize: '14px', lineHeight: '2.2', color: '#8a8da0' }}>
              <li><Link to="/faq" style={{ color: 'inherit' }}>FAQs</Link></li>
              <li><Link to="/shipping" style={{ color: 'inherit' }}>{lang === 'de' ? t('footer.shipping') : 'Shipping'}</Link></li>
              <li><Link to="/returns" style={{ color: 'inherit' }}>Returns</Link></li>
              <li><Link to="/warranty" style={{ color: 'inherit' }}>Warranty</Link></li>
            </ul>
          </div>

          {/* Newsletter */}
          <div>
            <h4 style={{ fontSize: '11px', letterSpacing: '2px', textTransform: 'uppercase', marginBottom: '22px', fontWeight: '600', color: 'var(--accent-gold)' }}>{lang === 'de' ? t('footer.newsletter.title') : 'Stay Updated'}</h4>
            <p style={{ fontSize: '13px', color: '#8a8da0', marginBottom: '15px', lineHeight: '1.6' }}>{lang === 'de' ? 'Erhalten Sie frühzeitigen Zugang zu neuen Kollektionen und exklusiven Angeboten.' : 'Get early access to new collections and exclusive offers.'}</p>
            <div style={{ display: 'flex', gap: '8px' }}>
              <input type="email" placeholder={lang === 'de' ? t('footer.newsletter.placeholder') : 'Your email'} style={{ flex: 1, padding: '12px 14px', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '6px', backgroundColor: 'rgba(255,255,255,0.05)', color: '#fff', fontSize: '13px', fontFamily: 'var(--font-sans)', outline: 'none' }} />
              <button className="btn-primary" style={{ borderRadius: '6px', padding: '12px 20px' }}>→</button>
            </div>
          </div>
        </div>
      </div>
      
      {/* Bottom Bar */}
      <div className="footer-bottom">
        <span>{lang === 'de' ? t('footer.copyright')(new Date().getFullYear()) : `© ${new Date().getFullYear()} Kaaleen Haus. All rights reserved.`}</span>
        <div style={{ display: 'flex', gap: '25px' }}>
          <Link to="/privacy" style={{ color: 'inherit' }}>{lang === 'de' ? t('footer.privacy') : 'Privacy Policy'}</Link>
          <Link to="/terms" style={{ color: 'inherit' }}>{lang === 'de' ? t('footer.terms') : 'Terms of Service'}</Link>
        </div>
      </div>

      <style>{`
        .footer-grid {
          display: grid;
          grid-template-columns: 1.5fr 1fr 1fr 1fr 1.2fr;
          gap: 40px;
        }
        .footer-bottom {
          background-color: #080d1a;
          padding: 18px 8%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 12px;
          color: #555770;
        }
        .footer-main {
          padding: 60px 8%;
        }
        @media (max-width: 1024px) {
          .footer-grid {
            grid-template-columns: 1.5fr 1fr 1fr;
            gap: 30px;
          }
        }
        @media (max-width: 768px) {
          .footer-main {
            padding: 40px 5%;
          }
          .footer-grid {
            grid-template-columns: 1fr 1fr;
            gap: 25px;
          }
        }
        @media (max-width: 576px) {
          .footer-main {
            padding: 40px 24px;
          }
          .footer-grid {
            grid-template-columns: 1fr 1fr;
            gap: 30px 16px;
            text-align: left;
          }
          .footer-grid > div:first-child {
            grid-column: 1 / -1;
            text-align: center;
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-bottom: 10px;
          }
           .footer-grid > div:last-child {
            grid-column: 1 / -1;
          }
          .footer-bottom {
            flex-direction: column;
            gap: 15px;
            text-align: center;
            padding: 24px;
          }
        }
        .footer-brand-row {
          display: flex;
          align-items: center;
          gap: 14px;
          margin-bottom: 20px;
        }
        .footer-brand-name {
          font-size: 18px;
          font-weight: 600;
          letter-spacing: 3px;
          color: #c9a96e;
        }
        @media (max-width: 576px) {
          .footer-brand-row {
            flex-direction: column;
            gap: 8px;
          }
          .footer-brand-name {
            font-size: 16px;
          }
        }
      `}</style>
    </footer>
  );
}
